import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children"];
import * as React from 'react';
export default function FooterRow(_ref) {
  var children = _ref.children,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("tr", props, children);
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/rc-table/es/Footer/Row.js
// module id = ./node_modules/rc-table/es/Footer/Row.js
// module chunks = 0